<template>
  <footer>
    <button @click="scrollToTop" class="scrollToTop"></button>
    <ul>
      <li class="usage-note">
        <button type="button" @click="openNotice" style="text-decoration: underline">
          ご利用上の注意
        </button>
      </li>
      <li class="copyright">Copyright &copy; Japan Weather Association. All Rights Reserved.</li>
    </ul>
    <NoticeModal />
  </footer>
</template>

<script setup lang="ts">
import NoticeModal from '@/components/modal/NoticeModal.vue'
import { useNoticeModalStore } from '@/stores/noticeModal'
import { watch, onUnmounted } from 'vue'
const store = useNoticeModalStore()
function openNotice() {
  store.open()
}

// ページトップへスクロール
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

// モーダルオープン時にスクロール禁止
watch(
  () => store.visible,
  (open) => {
    if (open) {
      document.body.classList.add('no-scroll')
    } else {
      document.body.classList.remove('no-scroll')
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  document.body.classList.remove('no-scroll')
})
</script>
